import { Button } from "@mui/material";
import styled from "@emotion/styled";

export const BaseButtonStyle = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  borderRadius: "60px",
  border: "1px solid",
  lineHeight: 1.5,
  backgroundColor: "#019df4",
  borderColor: "#019df4",
  fontFamily: [
    "Telefonica",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  "&:hover": {
    backgroundColor: "#0074B3",
    borderColor: "#0074B3",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#019df4",
    borderColor: "#019df4",
  },
  "&:disabled": {
    backgroundColor: "#80cef9",
    color: "#FFFFFF",
    borderColor: "#80cef9",
  },
  ".MuiButtonBase-root:disabled": {
    cursor: "not-allowed",
    "pointer-events": "auto",
  },
});